import React from 'react';
import { Action, Store } from 'redux';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';

import { ParagonThemeProvider } from '@paragon/themes';

import { RootState } from '../store';
import { darkTheme, lightTheme } from '../themes';
import PdfReviewClient from './PdfReviewClient';

interface Props {
  readonly reduxStore: Store<RootState, Action>;
}

export default function App(props: Props) {
  return (
    <React.StrictMode>
      <div>
        <Provider store={props.reduxStore}>
          <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme}>
            <CssBaseline />
            <PdfReviewClient />
          </ParagonThemeProvider>
        </Provider>
      </div>
    </React.StrictMode>
  );
}
